import {
  Center,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Select,
  SelectProps,
} from '@chakra-ui/react';
import { get } from 'lodash';
import Image from 'next/image';
import { Control, Controller, FieldError, UseFormWatch } from 'react-hook-form';

export interface IInputSelectOption {
  label: string;
  value: string;
}

type InputSelectGroupProp = {
  name: string;
  label?: string;
  placeholder?: string;
  description?: string;
  options: IInputSelectOption[];
  control: Control<any>;
  rules: any;
  watch?: UseFormWatch<any>;
};

function InputSelectGroup({
  name,
  label,
  placeholder,
  description,
  options,
  control,
  rules,
  watch,
  ...rest
}: InputSelectGroupProp & SelectProps) {
  return (
    <Controller
      control={control}
      render={({ field: { onChange, value }, formState: { errors } }) => {
        return (
          <FormControl
            isInvalid={
              (get(errors, name) as FieldError)?.message !== '' &&
              (get(errors, name) as FieldError)?.message !== undefined
            }
          >
            {label && <FormLabel mb={1}>{label}</FormLabel>}
            <Select
              {...rest}
              name={name}
              id={name}
              value={value || ''}
              onChange={onChange}
              placeholder={placeholder}
              _placeholder={{ color: 'gray.300' }}
              icon={
                <Center
                  width="16px !important"
                  height="10px !important"
                  mr={-2}
                >
                  <Image
                    src="/image-icon/dropdown.png"
                    width={16}
                    height={10}
                    alt="dropdown"
                  ></Image>
                </Center>
              }
            >
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Select>
            {description && <FormHelperText>{description}</FormHelperText>}
            {(get(errors, name) as FieldError)?.message && (
              <FormErrorMessage mt={1}>
                {(get(errors, name) as FieldError)?.message as string}
              </FormErrorMessage>
            )}
          </FormControl>
        );
      }}
      name={name}
      rules={rules}
    />
  );
}

export default InputSelectGroup;
